import React, { ReactElement, forwardRef, useImperativeHandle, useState } from "react";
import { Dispatch } from 'redux';
import { useDispatch } from "react-redux";

import CopyTasks from '@Components/NewProjectWizard/ContentWidgets/CopyTasks';

import Notification from '@Common/Notification';

import * as types from '@Constants/actionTypes';
import { NewProjectData } from "@Types/common";
import { actions as newProjectWizardActions } from '@Actions/newProjectWizardActions';

import { PublishProps } from "@Components/NewProjectWizard/Interfaces/PropTypes";

const CopyBaselineFromProject = forwardRef((props: { onCopyBaselineComplete: () => void | null } & PublishProps, ref): ReactElement => {
    const { projectData, subscriptionId, onCopyBaselineComplete } = props

    const dispatch: Dispatch = useDispatch();
    
    const copyProjectBaselines = async (request: any) => dispatch(newProjectWizardActions.copyProjectBaselines(request));

    const [isLoading, setIsLoading] = useState(false);
    const [project, setProject] = useState<NewProjectData>({
        id: projectData.id,
        name: projectData.name,
        description: projectData.description,
        abbreviation: projectData.abbreviation,
        projectManagerId: projectData.projectManagerId,
        supportAgentId: projectData.supportAgentId,
        isActive: projectData.isActive,
        projectKey: projectData.projectKey,
        locationIds: [],
        baselineIds: [],
    });

	// Called from child components
	const copyBaselineIdFromProject = (func: React.SetStateAction<NewProjectData>) => {
		setProject(func); // Pass callback from child component
	};

    const copyBaselines = async () => {
		setIsLoading(true);

		try {
            const request = {
                subscriptionId: subscriptionId,
                projectKey: project.projectKey,
                baselineIds: project.baselineIds.filter((value, index, array) => array.indexOf(value) === index), // Distinct values
            };
            const response = await copyProjectBaselines(request);
            if (response.type === types.NEW_PROJECT_WIZARD_COPY_PROJECT_BASELINES_SUCCESS) {
                onCopyBaselineComplete();
            } else if (response.type === types.NEW_PROJECT_WIZARD_COPY_PROJECT_BASELINES_FAILURE) {
                Notification('error', 'An Error Occurred', response.payload.message);
                setIsLoading(false);
            }
        } catch (error) {
            Notification('error', 'Error', error);
            setIsLoading(false);
        }
	};

    useImperativeHandle(ref, () => ({
        copyBaselines
    }));

    return <CopyTasks setProjectData={copyBaselineIdFromProject} setIsLoading={setIsLoading} />;
});

export default CopyBaselineFromProject;